let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bsLaU")).then(() => parcelRequire('6OvxG'));